(function () {
  'use strict';

  if (window.customElements.get('product-pack-sizes')) return;

  class ProductPackSizes extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll('button');
      this.quantityWrap = document.querySelector('.pdp-quantity-wrap');
      if (!this.buttons.length) return;
      this.addEventListener('click', this._onClick.bind(this));
      this._checkingExclusions = false;
      this.initialized = false;
      this._isUpdatingQtyFromPack = false;
      this._boundOnQuantityManualChange = this._onQuantityManualChange.bind(this);
      this._attachQuantityListeners();
      // Delay initial check to ensure Shopify.product is fully ready
      setTimeout(this._checkExclusions.bind(this), 300);
      // Also listen for product updates
      document.addEventListener('productUpdate', this._onProductUpdate.bind(this));
    }

    _onProductUpdate() {
      this._checkExclusions();
      if (this._isUpdatingQtyFromPack) return;
      var active = this.querySelector('[data-pack-size-quantity].active');
      if (!active || active.style.display === 'none') return;
      var q = parseInt(active.getAttribute('data-pack-size-quantity'), 10) || 1;
      if (q > 1) {
        this._syncPackSizeProperty(q);
      } else {
        this._removePackSizeProperty();
      }
    }

    _packSizeLineItemPropertyKey() {
      var v = window.Shopify && window.Shopify.variant;
      if (!v) return '_ - Pack Size Clicked';
      var sku = v.sku != null && String(v.sku).trim() !== '' ? String(v.sku).trim() : 'variant-' + v.id;
      return '_' + sku + ' - Pack Size Clicked';
    }

    _checkExclusions() {
      // Prevent multiple simultaneous checks
      if (this._checkingExclusions) return;
      
      var currentProductId = window.Shopify && window.Shopify.product && window.Shopify.product.id ? Number(window.Shopify.product.id) : null;
      if (!currentProductId) {
        // Wait for Shopify.product to be available
        setTimeout(this._checkExclusions.bind(this), 200);
        return;
      }

      this._checkingExclusions = true;

      var visibleButtons = [];
      var hiddenButtons = [];
      
      // First pass: determine which buttons should be visible/hidden based on exclusions
      this.buttons.forEach(function(btn) {
        var excludedProducts = btn.getAttribute('data-excluded-products');
        if (excludedProducts) {
          var excludedIds = excludedProducts.split(',').map(function(id) { return Number(id.trim()); });
          // console.log(excludedIds, currentProductId);
          if(excludedIds.includes(currentProductId)) {
            btn.style.display = 'none';
            hiddenButtons.push(btn);
          } else {
            // Only set display if it was previously hidden, otherwise leave it alone
            if (btn.style.display === 'none') {
              btn.style.display = '';
            }
            visibleButtons.push(btn);
          }
        } else {
          // No exclusions, ensure it's visible
          if (btn.style.display === 'none') {
            btn.style.display = '';
          }
          visibleButtons.push(btn);
        }
      });

      // Check for preselected button first (takes priority)
      var preselectedBtn = null;
      visibleButtons.forEach(function(btn) {
        var preselected = btn.getAttribute('data-preselected');
        if (preselected === 'true' || preselected === true) {
          preselectedBtn = btn;
        }
      });

      // If only one button remains visible, auto-select it and hide others
      if (visibleButtons.length === 1) {
        var autoSelectBtn = visibleButtons[0];
        this._selectButton(autoSelectBtn);

        visibleButtons.forEach(function(btn) {

            btn.style.display = 'none'; 

        });
      } else if (preselectedBtn) {
        // If there's a preselected button, select it (buttons already have correct display state)
        if (!this.initialized) {
          this._selectButton(preselectedBtn);
        }
      }
      // If multiple visible buttons and no preselected, buttons already have correct display state
      
      this._checkingExclusions = false;
      this.initialized = true;
    }

    _selectButton(btn) {
      var quantity = btn.getAttribute('data-pack-size-quantity');
      var buttonPrice = btn.getAttribute('data-pack-size-button-price');
      if (!quantity) return;
      var parsedQuantity = parseInt(quantity, 10) || 1;

      var mainQty = document.querySelector('#add-to-cart input[name="quantity"]');
      this._isUpdatingQtyFromPack = true;
      if (mainQty) {
        mainQty.value = quantity;
        mainQty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var stalkerQty = document.querySelector('#add-to-cart-stalker input[name="quantity"]');
      if (stalkerQty) {
        stalkerQty.value = quantity;
        stalkerQty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this._syncPackSizeProperty(parsedQuantity);
      this._isUpdatingQtyFromPack = false;

      if (buttonPrice) {
        window.pdpPackSize = { quantity: quantity, buttonPrice: buttonPrice };
        var displayPrice = buttonPrice;
        var strikePrice = '';
        if (typeof Shopify !== 'undefined' && window.Shopify && window.Shopify.variant) {
          var qty = parseInt(quantity, 10) || 1;
          // If there's a compare_at_price discount, calculate both prices from 1-pack prices × quantity
          if (Number(window.Shopify.variant.compare_at_price) > Number(window.Shopify.variant.price)) {
            var priceCents = window.pdpPriceToCents ? window.pdpPriceToCents(window.Shopify.variant.price) : (window.Shopify.variant.price >= 1000 ? window.Shopify.variant.price : Math.round(parseFloat(window.Shopify.variant.price) * 100));
            var compareAtCents = window.pdpPriceToCents ? window.pdpPriceToCents(window.Shopify.variant.compare_at_price) : (window.Shopify.variant.compare_at_price >= 1000 ? window.Shopify.variant.compare_at_price : Math.round(parseFloat(window.Shopify.variant.compare_at_price) * 100));
            displayPrice = Shopify.formatMoney(priceCents * qty, '').replace('.00', '');
            strikePrice = Shopify.formatMoney(compareAtCents * qty, '').replace('.00', '');
          } else {
            // No compare_at_price discount, use pack's custom buttonPrice
            displayPrice = buttonPrice;
            var unitCents = window.pdpPriceToCents ? window.pdpPriceToCents(window.Shopify.variant.price) : (window.Shopify.variant.price >= 1000 ? window.Shopify.variant.price : Math.round(parseFloat(window.Shopify.variant.price) * 100));
            strikePrice = Shopify.formatMoney(unitCents * qty, '').replace('.00', '');
          }
        }
        if (window.updateAddToCartButtonText) {
          window.updateAddToCartButtonText({ price: displayPrice, strikePrice: strikePrice, hasDiscount: true });
        }
      } else {
        window.pdpPackSize = null;
        if (window.handleProductUpdate && window.Shopify && window.Shopify.variant && window.Shopify.product) {
          window.handleProductUpdate(window.Shopify.variant, null, window.Shopify.product);
        }
      }

      this.buttons.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');

      if (this.quantityWrap !== null) {
        if (parseInt(quantity, 10) > 1) {
          this.quantityWrap.style.display = 'none';
        } else {
          this.quantityWrap.style.display = 'flex';
        }
      }

      this.dispatchEvent(new CustomEvent('packsizechange', {
        bubbles: true,
        detail: { quantity: quantity, buttonPrice: buttonPrice || null }
      }));
    }

    _onClick(e) {
      var btn = e.target.closest('button');
      if (!btn || btn.style.display === 'none') return;
      this._selectButton(btn);
    }

    _attachQuantityListeners() {
      var quantityInputs = document.querySelectorAll(
        '#add-to-cart input[name="quantity"], #add-to-cart-stalker input[name="quantity"], #quantity'
      );
      if (!quantityInputs.length) return;
      quantityInputs.forEach(function(input) {
        input.removeEventListener('change', this._boundOnQuantityManualChange);
        input.addEventListener('change', this._boundOnQuantityManualChange);
      }.bind(this));
    }

    _onQuantityManualChange() {
      if (this._isUpdatingQtyFromPack) return;
      this._removePackSizeProperty();
      window.pdpPackSize = null;
    }

    _syncPackSizeProperty(quantity) {
      if (quantity > 1) {
        this._setPackSizeProperty(quantity);
      } else {
        this._removePackSizeProperty();
      }
    }

    _setPackSizeProperty(quantity) {
      this._upsertPackSizeProperty('#add-to-cart', quantity);
      this._upsertPackSizeProperty('#add-to-cart-stalker', quantity);
    }

    _removePackSizeProperty() {
      this._removePackSizePropertyFromForm('#add-to-cart');
      this._removePackSizePropertyFromForm('#add-to-cart-stalker');
    }

    _upsertPackSizeProperty(formSelector, quantity) {
      var form = document.querySelector(formSelector);
      if (!form) return;
      this._removePackSizeManagedInput(form);
      var input = document.createElement('input');
      input.type = 'hidden';
      input.setAttribute('data-knickey-pack-size-line-item', '');
      input.name = 'properties[' + this._packSizeLineItemPropertyKey() + ']';
      input.value = String(quantity);
      form.appendChild(input);
    }

    _removePackSizeManagedInput(form) {
      var existing = form.querySelector('input[data-knickey-pack-size-line-item]');
      if (existing) existing.remove();
    }

    _removePackSizePropertyFromForm(formSelector) {
      var form = document.querySelector(formSelector);
      if (!form) return;
      this._removePackSizeManagedInput(form);
    } 
  }

  window.customElements.define('product-pack-sizes', ProductPackSizes);
})();